export default class ChartOptionsExtension
 {

    static TimeSeriesChartOptions(title, showLegend=true)
    {
        return {
            plugins: {
              title: {
                display: true,
                text: title,
              },
              legend: {
                display: showLegend
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'x',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'x',
                }
              }
            },
            responsive: true,
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true,
              },
            },
          };
    }

    static RankBarChartOptions(title)
    {
        return {
            plugins: {
              title: {
                display: true,
                text: title,
              },
              legend: {
                display: false,
                position: "right",
              }, 
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'x',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'x',
                }
              }
            },
            responsive: true
          };
    }


}
